import React from "react";
import { Routes, Route } from "react-router-dom";
import ChurchSiteLayout from "./pages/ChurchSiteLayout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import BeliefsPage from "./pages/BeliefsPage";
import GospelPage from "./pages/GospelPage";
import SermonsPage from "./pages/SermonsPage";
import MinistriesPage from "./pages/MinistriesPage";
import ResourcesPage from "./pages/ResourcesPage";
import VisitPage from "./pages/VisitPage";
import ContactPage from "./pages/ContactPage";
import "./website.css";

function Website() {
  return (
    <Routes>
      <Route element={<ChurchSiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="beliefs" element={<BeliefsPage />} />
        <Route path="gospel" element={<GospelPage />} />
        <Route path="sermons" element={<SermonsPage />} />
        <Route path="ministries" element={<MinistriesPage />} />
        <Route path="resources" element={<ResourcesPage />} />
        <Route path="visit" element={<VisitPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>
    </Routes>
  );
}

export default Website;
